import { toast } from "react-toastify";
import { handleAppError } from "./errorHandler";

export const SuccessToast = (message: string) => {
  toast.success(message, {
    type: "success",
  });
};

export const ErrorToast = (message: string) => {
  toast.success(message, {
    type: "error",
  });
};

export const WarningToast = (message: string) => {
  toast.success(message, {
    type: "warning",
  });
};

export const InfoToast = (message: string) => {
  toast.success(message, {
    type: "info",
  });
};

export const ErrorHandler = (errorObj: any) => {
  const error = handleAppError(errorObj);
  console.log("ErrorHandler", error);
  return toast(error, { type: "error" });
};

export const ToastFactory = (
  entity: "Quote" | "Invoice" | "Client",
  action: "Create" | "Update" | "Delete",
  success = true
) => {
  const msg = success
    ? `${entity} ${action.toLowerCase()}d successfully.`
    : `Failed to ${action.toLowerCase()} ${entity.toLowerCase()}. Please try again.`;

  success ? SuccessToast(msg) : ErrorToast(msg);
};
